"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMergeObject = deepMergeObject;
exports.transformLang = transformLang;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _vueJsonView = require("vue-json-view");

var _locale = require("../locale");

var _lodash = _interopRequireDefault(require("lodash"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var setDataByObj = _vueJsonView.Utils.setDataByObj,
    getDataByName = _vueJsonView.Utils.getDataByName;

function deepMergeObject(obj1, obj2) {
  obj1 = _objectSpread({}, obj1);
  Object.keys(obj2).forEach(function (key) {
    var newObj1 = obj1[key];
    var newObj2 = obj2[key];

    if (newObj1 && (0, _typeof2.default)(newObj1) === 'object') {
      if (Array.isArray(newObj1) && Array.isArray(newObj2)) {
        var list = newObj1.map(function (obj, i) {
          return newObj2[i] ? deepMergeObject(obj, newObj2[i]) : obj;
        });

        if (newObj2.length > list.length) {
          list = [].concat((0, _toConsumableArray2.default)(list), (0, _toConsumableArray2.default)(newObj2.slice(list.length)));
        }

        obj1[key] = list;
      } else {
        obj1[key] = deepMergeObject(newObj1, newObj2);
      }
    } else {
      obj1[key] = newObj2;
    }
  });
  return obj1;
}

function transformLang(obj) {
  var currentLang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _locale.getLang)();
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!obj) {
    return;
  }

  if (Array.isArray(obj)) {
    return obj.map(function (o) {
      return transformLang(o, currentLang, deep);
    });
  }

  var newObj = deep ? _lodash.default.cloneDeep(obj) : _objectSpread({}, obj);

  if (newObj._lang) {
    var currentLangLib = newObj._lang[currentLang] || {};
    newObj = deepMergeObject(newObj, currentLangLib);
  }

  if (newObj._childLang) {
    var childObj = getDataByName(newObj, newObj._childLang);
    newObj = setDataByObj(newObj, (0, _defineProperty2.default)({}, newObj._childLang, transformLang(childObj, currentLang, deep)));
  }

  delete newObj._lang;
  delete newObj._childLang;
  return newObj;
}